<ng-container *ngrxLet="packingListResource$ as packingListResource">
  <div class="erow" [class.last]="isLast" *ngIf="item">
    <div class="etext">
      <div class="item">
        <i
          class="ifc-custom ifc-chevron_down collapse-icon"
          [class.collapsed]="collapsed"
          (click)="toggleContent()"
        ></i>
        <img
          *ngIf="item.PackageType === packageTypes.SinglePacking"
          class="eimage"
          src="/img/ClosureImages/SinglePacking.png"
          alt="SinglePacking"
        />
        <img
          *ngIf="
            item.PackageType === packageTypes.Tank ||
            item.PackageType === packageTypes.Bulk
          "
          class="eimage"
          src="/img/ClosureImages/tanks-filled-red.png"
          [alt]="item.PackageType === packageTypes.Tank ? 'Tank' : 'Bulk'"
        />
        <label>{{ item.PackagingTitle }}</label>
        <span class="ch-ggs-web-suite-packing-cmds ml-auto">
          <button
            type="button"
            class="btn"
            (click)="edit()"
            [title]="packingListResource['EditPackage']"
          >
            <i
              class="ifc-custom ifc-pencil d-flex align-items-center justify-content-center"
              aria-hidden="true"
            ></i>
          </button>
          <button
            type="button"
            class="btn"
            (click)="copy()"
            [title]="packingListResource['CopyPackage']"
          >
            <i
              class="ifc-custom ifc-content_copy d-flex align-items-center justify-content-center"
              aria-hidden="true"
            ></i>
          </button>
          <button
            type="button"
            class="btn"
            (click)="remove()"
            [title]="packingListResource['RemoveDangerousGoodButton']"
          >
            <i
              class="ifc-custom ifc-bin d-flex align-items-center justify-content-center"
              aria-hidden="true"
            ></i>
          </button>
          <button
            *ngIf="!item.ParentId"
            type="button"
            class="btn"
            (click)="chooseOverpack()"
            [title]="packingListResource['AddOverpack']"
          >
            <i
              class="ifc ifc-stacked-boxes d-flex align-items-center justify-content-center"
              aria-hidden="true"
            ></i>
          </button>
          <button
            *ngIf="showPrintLabel"
            type="button"
            class="btn"
            (click)="printLabel()"
            [title]="packingListResource['PrintLabel']"
          >
            <i
              class="ifc-custom ifc-price-tag d-flex align-items-center justify-content-center"
              aria-hidden="true"
            ></i>
          </button>
        </span>
      </div>
      <span class="shipping-name" [class.collapsed]="collapsed">{{
        item.ProperShippingName
      }}</span>
    </div>
  </div>

  <lib-easydgd-overpack-modal
    *ngIf="!item.ParentId"
    [show]="showOverpackModal"
    [packageId]="item.Id"
    [overpackItems]="overpackItems"
    [overpackTitle]="packingListResource['OverPackModalTitle']"
    (closeOverpackModal)="editOverpack($event)"
    (selectOverpack)="selectOverpack($event)"
  ></lib-easydgd-overpack-modal>
</ng-container>
